/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ar/Green_Arrow': {
    width: 700,
    height: 700,
    viewBox: '0 0 700 700',
    data: '<path pid="0" d="M0 699.291C0 697.431 349.99-.699 350.57.001c1.95 2.354 350.07 699.46 349.43 699.72-.42.17-79.3-33.69-175.29-75.25l-174.52-75.55-174.25 75.54C80.112 666.011 1.32 700.001.85 700.001c-.467 0-.85-.32-.85-.71z" _fill="#0f0"/>'
  }
})
